export default function Navigation() {
    return (
        <nav className="p-3 navbar navbar-expand-lg navbar-dark bg-dark">
            <a className="navbar-brand" href="#">Horst Schönbeck</a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText"
                    aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarText">
                <ul className="navbar-nav mr-auto">
                    <li className="nav-item">
                        <a className="nav-link" href="#trailer">Anhänger</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#wheels">Reifen</a>
                    </li>
                    {/*<li className="nav-item">*/}
                    {/*    <a className="nav-link" href="#kfz">Kfz</a>*/}
                    {/*</li>*/}
                    <li className="nav-item">
                        <a className="nav-link" href="#anfahrt">Anfahrt</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#impressum">Impressum</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#datenschutz">Datenschutz</a>
                    </li>
                </ul>
            </div>
        </nav>
    );
}